import { render, staticRenderFns } from "./delayTipsDialog.vue?vue&type=template&id=766ed3cc&scoped=true"
import script from "./delayTipsDialog.vue?vue&type=script&lang=js"
export * from "./delayTipsDialog.vue?vue&type=script&lang=js"
import style0 from "./delayTipsDialog.vue?vue&type=style&index=0&id=766ed3cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766ed3cc",
  null
  
)

export default component.exports